const party = {
  SHIPPER: 1,
  TRANSPORTER: 2,
  EPOD: 3, // added for displaying epod comments in wallet
};

module.exports = {
  party,
};
